
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#62C4C3","d":"M55 17H39.479a6 6 0 00-5.975 5.457L33 28l-8 6 4 5 10-7v-8h16v14h6V23a6 6 0 00-6-6z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M39 24v14l-4 24h8l4-24v24h8V24z"}}),_c('circle',{attrs:{"cx":"47","cy":"10","r":"7","fill":"#62C4C3"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M10 3h2v4h-2z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M9 2h4v2H9zM2.705 8.366l1-1.732 3.464 2-1 1.732z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M1.34 8.732l2-3.465 1.732 1-2 3.465zM2.706 15.634l3.464-2 1 1.733-3.465 2z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M1.339 15.268l1.732-1 2 3.464-1.732 1zM10 17h2v4h-2z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M9 20h4v2H9zM14.83 15.366l1-1.732 3.464 2-1 1.732z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M16.929 17.731l2-3.464 1.732 1-2 3.464zM14.831 8.634l3.465-2 1 1.733-3.465 2z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M16.928 6.269l1.732-1 2 3.464-1.732 1z"}}),_c('circle',{attrs:{"cx":"11","cy":"12","r":"6","fill":"#AA494A"}}),_c('circle',{attrs:{"cx":"11","cy":"12","r":"4","fill":"#D36767"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M31.707 16.707l-1.414-1.414L33.586 12l-3.293-3.293 1.414-1.414L36.414 12z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M25 11h10v2H25zM21 11h2v2h-2zM45.335 13.709a4.006 4.006 0 00-4.594-.762l-.883-1.795a6.012 6.012 0 016.887 1.138l-1.41 1.419zM46 21h2v8h-2zM46 31h2v2h-2z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M55 24h2v14h-2zM39 24h2v8h-2z"}})])
          )
        }
      }
    